import { render, staticRenderFns } from "./CreditLoanTypeSettings.vue?vue&type=template&id=2eccb550"
import script from "./CreditLoanTypeSettings.vue?vue&type=script&lang=js"
export * from "./CreditLoanTypeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports